/* Theme-scoped integration: Intelligems renders its native progress component.
 * Never overwrite Upcart's React-managed shipping text or shared app settings. */
(() => {
  const stateElement = document.getElementById('shipping-cart-state');
  if (!stateElement) return;
  let cart;
  try { cart = JSON.parse(stateElement.textContent); } catch { return; }
  const cartUrl = cart.cart_url;
  const currency = cart.currency;
  let root;
  let signature;
  let timer;
  let revision = 0;
  const isTreatment = () => document.documentElement.dataset.shippingTestGroup === 'treatment';
  const usable = () => isTreatment() && currency === 'USD' && (cart === null || cart.requires_shipping);
  const shippingAmount = () => !Number.isInteger(cart?.total_price) ? 'Calculated at checkout' : cart.total_price >= 15000 ? 'FREE' : '$9.95';

  function render() {
    const active = usable();
    document.querySelectorAll('[data-shipping-treatment-summary] [data-shipping-copy]').forEach((element) => {
      if (!active) return;
      const message = `Standard US shipping: ${shippingAmount()}`;
      element.setAttribute('data-shipping-treatment', message);
      if (element.textContent !== message) element.textContent = message;
    });
    if (!root) return;
    let style = root.getElementById('shipping-treatment-cart-style');
    let bar = root.getElementById('shipping-treatment-progress');
    let widget = root.host.querySelector('[data-shipping-native-widget]');
    if (!active) {
      style?.remove();
      bar?.remove();
      widget?.remove();
      return;
    }
    if (!style) {
      style = document.createElement('style');
      style.id = 'shipping-treatment-cart-style';
      style.textContent = `
        #custom-shipping-line { align-items: center; gap: 12px; }
        #custom-shipping-line > .custom-shipping-line__shipping { display: none !important; }
        #custom-shipping-line::after { content: var(--shipping-amount); font-size: 14px; text-align: right; }
        #shipping-treatment-progress { display: block; padding: 12px 20px; }
      `;
      root.append(style);
    }
    const amount = JSON.stringify(shippingAmount());
    if (root.host.style.getPropertyValue('--shipping-amount') !== amount) {
      root.host.style.setProperty('--shipping-amount', amount);
    }
    const header = root.querySelector('.upcart-public-header');
    if (!bar && header) {
      bar = document.createElement('slot');
      bar.id = 'shipping-treatment-progress';
      bar.name = 'shipping-progress';
      header.after(bar);
    }
    if (!widget && header) {
      // Keep the native component in light DOM so Intelligems can discover it.
      // A named slot displays it inside Upcart's shadow DOM, below the header.
      widget = document.createElement('ig-progress-bar');
      widget.setAttribute('data-shipping-native-widget', '');
      widget.slot = 'shipping-progress';
      root.host.append(widget);
    }

  }

  async function refresh(expectedRevision) {
    try {
      const response = await fetch(cartUrl, {headers: {Accept: 'application/json'}, cache: 'no-store'});
      if (!response.ok) throw new Error(`Cart request failed (${response.status})`);
      const next = await response.json();
      if (expectedRevision !== revision) return;
      cart = next;
      render();
    } catch (error) {
      if (expectedRevision !== revision) return;
      // Do not keep claiming free shipping using a stale total after a failed refresh.
      cart = null;
      render();
      console.warn('[Shipping test] Cart unavailable; shipping calculated at checkout.', error);
    }
  }

  function scheduleRefresh() {
    const expectedRevision = ++revision;
    clearTimeout(timer);
    timer = setTimeout(() => refresh(expectedRevision), 120);
  }

  function inspectCart() {
    const nextRoot = document.getElementById('upCart')?.shadowRoot;
    if (nextRoot !== root) {
      cartObserver.disconnect();
      root = nextRoot;
      signature = undefined;
      if (root) cartObserver.observe(root, {childList: true, characterData: true, attributes: true, subtree: true});
    }
    if (root && isTreatment()) {
      // Only app-owned cart content participates. Our widget and CSS cannot
      // trigger a fetch/observer feedback loop, even while its progress animates.
      const nextSignature = [
        root.querySelector('.upcart-public-cart-items')?.innerHTML,
        root.querySelector('.upcart-public-cart-summary')?.innerHTML,
        root.querySelector('[class*="cartSubtotalValue"]')?.textContent,
      ].join('|');
      if (signature !== nextSignature) {
        signature = nextSignature;
        scheduleRefresh();
      }
    }
    render();
  }

  const cartObserver = new MutationObserver(inspectCart);
  const hostObserver = new MutationObserver(inspectCart);
  hostObserver.observe(document.body, {childList: true, subtree: true});
  document.addEventListener('cart:change', (event) => {
    if (!event.detail?.cart) return;
    ++revision;
    clearTimeout(timer);
    cart = event.detail.cart;
    render();
  });
  window.addEventListener('latico:shipping-group', () => {
    signature = undefined;
    inspectCart();
    if (isTreatment() && !root) scheduleRefresh();
  });
  window.addEventListener('pagehide', () => {
    ++revision;
    clearTimeout(timer);
    hostObserver.disconnect();
    cartObserver.disconnect();
  });
  window.addEventListener('pageshow', (event) => {
    if (!event.persisted) return;
    hostObserver.observe(document.body, {childList: true, subtree: true});
    root = undefined;
    inspectCart();
    if (isTreatment()) scheduleRefresh();
  });
  inspectCart();
})();
